module.exports = __webpack_public_path__ + "media/images/talent/flow-image01-37a57d4bf88d7c784c311a0d938202eb.png";